export const ACCEPT_LANGUAGE = {
  DEFAULT: "en-us",

  ARG: "es-ar",
  CHL: "es-cl",
  MEX: "es-mx",
  ESP: "es-es",
  PER: "es-pe",
  PRI: "es-pr",
  VEN: "es-ve",
  COL: "es-co",
  ECU: "es-ec",
  URY: "es-uy",
  BRA: "pt-br",
  USA: "en-us",
  GTM: "es-gt",
  SLV: "es-sv",
  DOM: "es-do",
  BOL: "es-bo",

  es: "es-mx",
  pt: "pt-br",
  en: "en-us"
};
